<template>
    <Box title="预防性计划实施" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <van-tabs @click="propconfirm" swipeable background="rgba(0,0,0,0)" line-width="20px" v-model="tabsIndex">
            <van-tab :title="'未执行('+Total+'台)'">
                <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">
                    <div class="ArrayItems">
                        <div class="items" v-for="item in list" @click="Preventionout(item,'Y')">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <div>
                                        <span class="ellipsis">{{item.EquName}}</span>
                                        <img src="../../assets/img/right.png" />
                                    </div>
                                    <div>
                                        <div>
                                            <p>资产编号:</p>
                                            <p>计划名称:</p>
                                            <p>使用科室:</p>
                                            <p>检测类型:</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.EquId}}</p>
                                            <p class="ellipsis">{{item.OrderName}}</p>
                                            <p class="ellipsis">{{item.DepName}}</p>
                                            <p class="ellipsis">{{item.TestingName}}</p>
                                        </div>
                                        <div class="button">
                                            <div>执行计划</div>
                                            <div @click.stop="stop(item)">终止计划</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span>下次维护时间</span>
                                <span>{{item.NextKeepDate}}</span>
                            </div>
                        </div>
                    </div>
                </LoadingFooter>
            </van-tab>
            <van-tab :title="'已执行('+TotalSecond+'台)'">
                <LoadingFooter v-model="loadingSecond" :finished="finishedSecond" @load="onLoadSecond" @scroll="IsSee=false">
                    <div class="ArrayItems">
                        <div class="items" v-for="item in listSecond" @click="Preventionout(item,'N')">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <div>
                                        <span class="ellipsis">{{item.EquName}}</span>
                                        <img src="../../assets/img/right.png" />
                                    </div>
                                    <div>
                                        <div>
                                            <p>资产编号:</p>
                                            <p>计划名称:</p>
                                            <p>使用科室:</p>
                                            <p>检测类型:</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.EquId}}</p>
                                            <p class="ellipsis">{{item.OrderName}}</p>
                                            <p class="ellipsis">{{item.DepName}}</p>
                                            <p class="ellipsis">{{item.TestingName}}</p>
                                        </div>
                                        <div class="button">
                                            <div>查看</div>
                                            <!-- <div @click.stop="stop(item)">终止计划</div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span>下次维护时间</span>
                                <span>{{item.NextKeepDate}}</span>
                            </div>
                        </div>
                    </div>

                </LoadingFooter>
            </van-tab>
        </van-tabs>
        <transition name="fade">
            <div class="menu" v-show="IsSee" key='1'>
                <Field title="资产名称" placeholder="请输入编号或者名称" @onMessage="value => search.EquName = value" />
                <Field title="使用科室" placeholder="请输入编号或者名称" @onMessage="value => search.SYKS = value" />
                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StartDate = value" />
                <Field title="结束时间" :DateMax="DateMax" :text='search.EndDate' placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import {
        ExistsEdorIng
    } from '../../../tool/api/api.js'
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import {
        Tab,
        Tabs
    } from 'vant'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'Prevent',
        data() {
            return {
                DateMax:new Date(new Date().getFullYear()+1,'01','01'),
                search: {
                    EquName: null,
                    SYKS: null,
                    StartDate: null,
                    EndDate: this.$format(new Date().setDate(new Date().getDate() + 7), 'YYYY-MM-DD'),
                },
                // searchSecond: { //已执行搜索条件
                //     EquName: null,
                //     SYKS: null,
                //     StartDate: null,
                //     EndDate: this.$format(new Date().setDate(new Date().getDate() + 7), 'YYYY-MM-DD'),
                // },
                loading: true,
                finished: false,
                list: [],
                touchStartY: 0,
                IsSee: false,
                page: 10,
                Total: 0,
                tabsIndex: 0,
                listSecond: [],
                pageSecond: 10, //已加载页码
                TotalSecond: 0, //已执行总数量
                loadingSecond: false, //已执行加载状态
                finishedSecond: false, //已执行显示状态
                touchStartYSecond: 0, //已执行滚动条滚动量
                IsSeeSecond: false, //已执行是否显示
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        activated() {
            this.loadDataDefault();
        },
        methods: {
            serach() {
                this.IsSee=false;
                if(this.tabsIndex===0){
                    this.page = 10;
                    this.loadDataDefault()
                }else if(this.tabsIndex===1){
                    this.pageSecond=10;
                    this.loadDataSecondDefault()
                }
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 10;
                    this.loadDataDefault();
                }
            },
            stop(item) { //终止计划
                this.$Dialog.confirm({
                    message: '确定终止?'
                }).then(() => {
                    this.$post('api/YF/StopKeep', {
                        Store: this.$UserInfo.StoreCode,
                        UserCode: this.$UserInfo.UserId,
                        EquId: item.EquId,
                        OrderNo: item.OrderNo,
                        NextKeepDate: item.NextKeepDate
                    }).then(result => {
                        this.$Toast(result.Msg);
                        if (result.Status) {
                            setTimeout(x => {
                                this.loadDataDefault();
                            }, 2000);
                        }
                    })
                }).catch(() => {})
            },
            loadDataDefault() {
                this.$post('api/YF/BYList', {
                    Store: this.$UserInfo.StoreCode,
                    UserCode: this.$UserInfo.UserId,
                    EquName: this.search.EquName, //设备名称
                    StartDate: this.search.StartDate, //开始
                    EndDate: this.search.EndDate, //结束
                    SYKS: this.search.SYKS, //科室
                    PageIndex: 1,
                    PageSize: this.page
                }).then(result => {
                    this.Total = result.Total;
                    this.list = result.BYList;
                    if (this.page >= this.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                })
            },
            /**********************************************已执行************************************************/
            propconfirm() {
                this.IsSee=false;
                this.tabsIndex===0?this.loadDataDefault():this.loadDataSecondDefault();
            },
            loadDataSecondDefault() {
                this.$post('api/YF/GetPreventabilityExecuted', {
                    Store: this.$UserInfo.StoreCode,
                    UserCode: this.$UserInfo.UserId,
                    EquName: this.search.EquName,
                    StartDate: this.search.StartDate,
                    EndDate: this.search.EndDate,
                    SYKS: this.search.SYKS,
                    PageIndex: 1,
                    PageSize: this.pageSecond
                }).then(result => {
                    if (result.BYList) {
                        this.listSecond = result.BYList;
                        this.TotalSecond = result.Total;
                        if (this.pageSecond > this.TotalSecond) {
                            this.loadingSecond = false;
                            this.finishedSecond = true;
                        } else this.loadingSecond = false;
                    }
                })
            },
            onLoadSecond() { //已执行下拉加载数据
                if (!this.loadingSecond && !this.finishedSecond) {
                    this.pageSecond += 10;
                    this.loadDataSecondDefault();
                }
            },
            onScrollSecond(value) { //已执行滚动条滚动检测
                if (value > this.touchStartYSecond) {
                    this.touchStartYSecond = value
                    this.IsSeeSecond = false;
                } else if ((this.touchStartYSecond - value) > 200) {
                    this.touchStartYSecond = value
                    this.IsSeeSecond = true;
                }
            },
            Preventionout(item, state) { //预防已执行点击事件
                ExistsEdorIng(1, state, 'QualityTest', item);
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .menu {
        top: 220px;
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;
                        flex: 1;

                        &>div {
                            display: flex;

                            &:first-child {
                                margin-bottom: 18px;
                                display: flex;

                                span:first-child {
                                    color: $TEXT-DARK-COLOR;
                                    font-weight: bold;
                                    font-size: 32px;
                                    flex: 1;
                                    width: 208px;
                                }

                                span:nth-child(2) {
                                    color: $TEXT-DARK-COLOR;
                                    font-size: 28px;
                                    margin-left: 10px;
                                    width: 158px;
                                    text-align: right;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }

                            &:nth-child(2) {
                                p {
                                    color: #999;
                                    font-size: 26px;
                                    line-height: 45px;
                                    height: 45px;
                                }

                                &>div:nth-child(2) {
                                    p {
                                        width: 200px;
                                    }
                                }
                            }
                        }

                        .button {
                            margin-left: 10px;
                            margin-top: 20px;

                            div {
                                width: 152px;
                                height: 60px;
                                border-radius: 30px;
                                background: $THEME-COLOR;
                                font-size: 26px;
                                color: #fff;
                                text-align: center;
                                line-height: 60px;
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }

    .ArrayItems{
        margin-top:100px;
    }
</style>



// WEBPACK FOOTER //
// src/page/prevent/prevent.vue